module.exports = __webpack_public_path__ + "img/web_links-w.svg";